import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      paddingTop: '8px',
      paddingBottom: '16px',
    },
  },
};

export const BODY_CONTENT: BlockOverrides = {
  Block: {
    style: {
      textAlign: 'left',
      marginTop: '24px',
      marginBottom: '32px',
      fontSize: '16px',
      color: THEME.colors.muted300,
    },
  },
};
